// src/utils/preventZoom.ts
export const preventZoom = () => {
  // Forzar zoom al 100% inmediatamente
  const setZoom = () => {
    if (document.body) {
      const dpr = window.devicePixelRatio || 1;
      const sw = window.screen.width;
      // const sh = window.screen.height;
      const vw = window.innerWidth;

      // Calcular ancho físico real estimado
      // En muchos navegadores de TV, screen.width devuelve píxeles lógicos
      const physicalWidth = Math.max(sw * dpr, vw * dpr);

      // Usar meta viewport si existe
      let viewport = document.querySelector('meta[name="viewport"]');
      if (!viewport) {
        viewport = document.createElement('meta');
        viewport.setAttribute('name', 'viewport');
        document.head.appendChild(viewport);
      }

      // DETERMINAR POLÍTICA DE VIEWPORT
      // Si detectamos una TV (physicalWidth >= 1280) y el viewport está escalado (dpr > 1)
      // forzamos el ancho al físico para que el navegador rinda 1:1 y no aplique zoom "inteligente"
      if (physicalWidth >= 1280 && dpr > 1) {
        console.log('[preventZoom] TV detectada con zoom. Forzando ancho físico:', physicalWidth);
        viewport.setAttribute(
          'content',
          `width=${physicalWidth}, initial-scale=${1 / dpr}, maximum-scale=${1 / dpr}, user-scalable=no, viewport-fit=cover`
        );
      } else {
        viewport.setAttribute(
          'content',
          'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover'
        );
      }

      // Fallback: Usar document.body.style.zoom (si está disponible)
      if ('zoom' in document.body.style) {
        (document.body.style as any).zoom = '1';
      }
    }
  };

  // Ejecutar inmediatamente
  setZoom();

  // Ejecutar después de que el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setZoom);
  }

  // Ejecutar después de que la página cargue completamente
  window.addEventListener('load', setZoom);

  // Monitorear cambios de viewport (útil para detectar zoom inesperado)
  if (window.visualViewport) {
    const visualViewport = window.visualViewport;
    visualViewport.addEventListener('resize', () => {
      const scale = visualViewport.scale;
      if (scale !== 1) {
        console.warn('Zoom detectado:', scale);
        setZoom();
      }
    });
  }

  // Prevenir gestos de zoom (touch events)
  document.addEventListener('gesturestart', (e) => (e as any).preventDefault());
  document.addEventListener('gesturechange', (e) => (e as any).preventDefault());
  document.addEventListener('gestureend', (e) => (e as any).preventDefault());

  // Prevenir wheel zoom con Ctrl/Cmd
  document.addEventListener('wheel', (e) => {
    if (e.ctrlKey || e.metaKey) {
      e.preventDefault();
    }
  }, { passive: false });

  // Prevenir zoom con teclado (Ctrl/Cmd + Plus/Minus)
  document.addEventListener('keydown', (e) => {
    if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-' || e.key === '=' || e.key === '0')) {
      e.preventDefault();
    }
  });
};

// Llamar la función al importar
if (typeof window !== 'undefined') {
  preventZoom();
}

